export default __webpack_public_path__ + "static/accents-colors-light-37de00fc0f52ef820ab986bb3f454148.png";